var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1154_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6154 34.6153H30.7693V36.923H34.8001C35.9693 36.923 36.9077 35.9538 36.9077 34.7692V30.7692H34.6001V34.6153H34.6154Z",
    fill: "#FF006E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2461 24.9384C27.2461 20.9384 24 17.6923 20 17.6923C19.8769 17.6923 19.7384 17.6923 19.6154 17.6923C15.7692 17.8923 12.7538 21.2 12.7538 25.2V34.6H5.3846V17.8461L20 5.44614L34.6154 17.8615V30.8035H36.9231V17.8154C36.9231 17.1692 36.6461 16.5692 36.1538 16.1538L21.3538 3.56921C20.9692 3.23075 20.4769 3.0769 20 3.0769C19.5231 3.0769 19.0308 3.24613 18.6461 3.56921L3.83075 16.1538C3.35383 16.5692 3.0769 17.1692 3.0769 17.8V34.7692C3.0769 35.9538 4.03075 36.9231 5.19998 36.9231H12.9538C14.1231 36.9231 15.0769 35.9692 15.0769 34.8V25.2C15.0769 22.5231 17.0769 20.1384 19.7538 19.9846C19.8461 19.9846 19.9384 19.9846 20.0154 19.9846C22.7384 19.9846 24.9538 22.2 24.9538 24.9231V34.8C24.9538 35.9692 25.9077 36.9231 27.0769 36.9231H30.8V34.6154H27.2769V24.9384H27.2461Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1154_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.9c4c2052a3a412e8937bf68f68e22dac.svg";
export { ForwardRef as ReactComponent };